<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">
          {{ editRoute ? $t("labels.edit_project") : $t("labels.add_project") }}
        </h2>
      </div>
    </div>
    <form @submit.prevent autocomplete="off">
      <vx-card class="page-bg-color addedit-question">
        <vs-row class="flex w-full vx-row mx-auto p-2">
          <div class="vx-col sm: w-full md:w-full lg:w-1/1 d-theme-dark-bg p-0">
            <!-- Project Name -->
            <div class="vx-row w-full m-0">
              <div class="vx-col sm: w-full md:w-1/2 sm: pr-0 md:pr-4 pl-0">
                <label class="bold-fields">{{
                  $t("labels.project_name")
                }}</label>
                <vs-input
                  type="text"
                  class="w-full mb-0 mt-1"
                  name="project_name"
                  maxlength="250"
                  v-model="project_name"
                  icon-no-border
                  v-validate="'required'"
                  height="150"
                  data-vv-scope="form1"
                />
                <span class="text-danger text-sm">{{
                  errors.first("form1.project_name")
                }}</span>
              </div>
              <!-- Date -->
              <div
                class="vx-col sm: w-full md:w-1/2 sm: pl-0 md:pl-4 pr-0 sm: mt-6 md:mt-0"
              >
                <label class="font flex items-baseline"
                  >{{ $t("labels.date") }}
                  <i
                    :title="$t('labels.date_placeholder')"
                    class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null ml-2 text-primary"
                  ></i>
                </label>
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="date"
                  class="mt-1"
                  name="date"
                  inputmode="true"
                  placeholder="Select Date"
                  data-vv-scope="form1"
                />
                <!-- <span class="text-danger text-sm">{{
                  errors.first("form1.date")
                }}</span> -->
              </div>
            </div>
            <div class="mt-6">
              <div class="vx-row">
                <!-- Vessel -->
                <div class="vx-col sm: w-full md:w-1/2">
                  <label class="bold-fields">{{ $t("labels.vessel") }}</label>
                  <button
                    class="btn-link"
                    v-if="$store.state.userInfo.type == 'A'"
                    @click="addVesslePopup = true"
                  >
                    Add new vessel
                  </button>
                  <div class="w-full flex">
                    <vs-button
                      @click="popupActive = true"
                      color="dark"
                      :title="$t('strings.select_client_for_vessel')"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-maximize-2"
                      class="mt-1"
                    ></vs-button>
                    <vs-input
                      disabled
                      type="text"
                      class="w-full mb-0 mt-1 ml-2 vessel-input"
                      name="vessel"
                      maxlength="250"
                      v-model="selected_type"
                      icon-no-border
                      v-validate="'required'"
                    />
                  </div>
                  <span class="text-danger text-sm">{{
                    errors.first("vessel")
                  }}</span>
                </div>
                <!-- Reviewer -->
                <div
                  class="vx-col sm: w-full md:w-1/2 sm: mt-6 md:mt-0"
                  style="
                    display: flex;
                    flex-direction: column;
                    justify-content: end;
                  "
                >
                  <label class="bold-fields">{{ $t("labels.reviewer") }}</label>
                  <v-select
                    v-model="admin"
                    name="reviewer"
                    :options="admins"
                    :reduce="(admins) => admins"
                    class="mt-1"
                    label="name"
                  />
                  <!-- <span class="text-danger text-sm">{{
                    errors.first("reviewer")
                  }}</span> -->
                </div>
              </div>
            </div>
            <!-- Ports -->
            <div class="vx-row">
              <div class="vx-col w-full px-4 mt-6">
                <label class="font">{{ $t("labels.ports") }}</label>
                <v-select
                  v-model="port_id"
                  class="mt-1"
                  :options="ports"
                  name="port"
                  :reduce="(port) => port.id"
                  label="name"
                />
                <!-- <span class="text-danger text-sm">{{
                  errors.first("port")
                }}</span> -->
              </div>
            </div>
            <!-- Services & Consultants -->
            <div class="vx-row">
              <div class="vx-col w-full px-4 mt-6">
                <label class="font">{{ $t("labels.services") }}</label>
                <v-select
                  multiple
                  v-model="service"
                  :options="services_drop"
                  :reduce="(services_drop) => services_drop"
                  label="name"
                  name="services"
                  class="mt-1"
                  :closeOnSelect="false"
                />
                <!-- <span class="text-danger text-sm">{{
                  errors.first("services")
                }}</span> -->
              </div>
              <div class="vx-col w-full px-4 mt-6">
                <label class="font">{{ $t("labels.consultants") }}</label>
                <v-select
                  multiple
                  v-model="consultant"
                  :options="consultants_drop"
                  :reduce="(consultants_drop) => consultants_drop"
                  label="name"
                  class="mt-1"
                  name="consultants"
                  :closeOnSelect="false"
                />
                <!-- <span class="text-danger text-sm">{{
                  errors.first("consultants")
                }}</span> -->
              </div>
            </div>
            <div
              class="vx-row w-full mx-0 mt-6"
              v-for="(
                specific_consultant_services, index
              ) in consultant_services_array"
              :key="`sp_service_${index}`"
            >
              <div class="vx-col sm: w-full pl-0 pr-0">
                <div class="vx-row ml-0 mb-4">
                  <div class="w-full sm: mb-2 md:mb-0 flex">
                    <label class="pl-1"
                      >{{ $t("labels.services") }}({{
                        specific_consultant_services.consultant_name
                      }})</label
                    >
                    <vs-checkbox
                      @click="checkAllServices($event, index)"
                      v-model="specific_consultant_services.checkall"
                      class="sm: mb-2 md:mb-0 pr-6 mt-1 ml-4"
                      >{{ $t("labels.all") }}</vs-checkbox
                    >
                  </div>
                  <div
                    v-for="(services_for_consultant, sfcindex) in service"
                    :key="`sfc_${sfcindex}`"
                    class="vx-col sm: w-full md:w-1/3 pr-6 pl-0 flex mb-2 mt-2"
                  >
                    <vs-checkbox
                      v-model="specific_consultant_services.service_ids"
                      :name="
                        'services for ' +
                        specific_consultant_services.consultant_name
                      "
                      :vs-value="services_for_consultant.id"
                      :id="'service_cl' + services_for_consultant.id"
                      @click="checkServices($event, index)"
                      >{{ services_for_consultant.name }}</vs-checkbox
                    >
                  </div>
                  <div class="w-full">
                    <!-- <span class="text-danger text-sm pl-2">{{
                      errors.first(
                        "services for " +
                          specific_consultant_services.consultant_name
                      )
                    }}</span> -->
                  </div>
                </div>
                <!-- Work Instruction -->
                <div class="vx-row w-full mx-auto">
                  <div class="sm: w-full md:w-1/2 sm: pr-0 md:pr-4">
                    <label class
                      >{{ $t("labels.work_instructions") }} ({{
                        specific_consultant_services.consultant_name
                      }})</label
                    >
                    <vs-textarea
                      type="text"
                      class="w-full mb-0 mt-1"
                      :name="
                        'work_instructions_' +
                        specific_consultant_services.consultant_name
                      "
                      maxlength="5000"
                      v-model="
                        specific_consultant_services.work_instructions_text
                      "
                      icon-no-border
                    />
                    <!-- <span class="text-danger text-sm">{{
                      errors.first(
                        "work_instructions_" +
                          specific_consultant_services.consultant_name
                      )
                    }}</span> -->
                  </div>
                  <!-- Attachment -->
                  <div
                    v-if="
                      !specific_consultant_services.work_instructions_attachment
                        .length > 0
                    "
                    class="sm: w-full md:w-1/2 sm: pl-0 md:pl-4 pr-0 sm: mt-6 md:mt-0"
                  >
                    <label class>
                      {{ $t("labels.work_instruction_attachment") }}
                      ({{ specific_consultant_services.consultant_name }})
                    </label>
                    <div>
                      <vs-button
                        color="dark"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-link"
                        @click="showUploadPopup(index)"
                      >
                        Attach Documents
                      </vs-button>
                    </div>
                  </div>

                  <div
                    v-if="
                      specific_consultant_services.work_instructions_attachment
                        .length > 0
                    "
                    class="w-full mt-6 p-5 border rounded-md"
                  >
                    <label class="text-dark font-bold">{{
                      $t("labels.work_instruction_attachment")
                    }}</label>
                    <div
                      v-for="(
                        attachment, attachIndex
                      ) in specific_consultant_services.work_instructions_attachment"
                      :key="attachIndex"
                    >
                      <div class="mt-5 flex justify-between sm: block md:flex">
                        <div class="flex justify-center items-center space-x-2">
                          <label
                            class="border border-dark rounded-5 text-dark h-10 flex items-center px-3"
                          >
                            {{ getFileName(attachment) }}
                          </label>
                          <vs-button
                            color="danger"
                            type="border"
                            class="mr-4 float-right mb-2"
                            icon-pack="feather"
                            icon="icon-x"
                            v-model="cancel"
                            @click.prevent="clearFileName(index, attachIndex)"
                          ></vs-button>
                        </div>

                        <vs-button
                          v-if="
                            specific_consultant_services.work_instructions_attachment
                          "
                          @click="
                            popupPreview = true;
                            file_preview_url =
                              specific_consultant_services
                                .work_instructions_attachment[attachIndex];
                          "
                          color="dark"
                          class="sm: mt-4 md:mt-0"
                          >{{ $t("labels.preview_attachment") }}</vs-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Remarks -->
            <div class="vx-col sm: w-full pl-0 pr-0 mt-6 mb-6">
              <label class>{{ $t("labels.remarks") }}</label>
              <vs-textarea
                type="text"
                class="w-full mb-0 mt-1"
                name="remarks"
                maxlength="5000"
                v-model="remarks"
                icon-no-border
              />
            </div>
            <div class="vx-col w-full m-0 mt-4" v-if="sections.length">
              <InspectionImage
                ref="inspectionImg"
                :sectionInfo="sections"
                :vesselSubTypeInfo="vesselSubTypeInfo"
                :project="projectInfo"
                page="addEditProject"
              />
            </div>

            <!-- Buttons -->
            <div class="mt-2 flex justify-center project-button">
              <vs-button
                :disabled="button_loading"
                color="primary"
                type="filled"
                class="mr-4"
                v-model="status"
                id="save_as_draft"
                @click="checkValidation('DR')"
                >{{ $t("labels.save_as_draft") }}</vs-button
              >
              <vs-button
                :disabled="button_loading"
                type="filled"
                color="primary"
                v-model="status"
                id="save_as_new"
                @click.prevent="checkValidation('C')"
                >{{ $t("labels.save_as_confirm") }}</vs-button
              >
            </div>
          </div>
        </vs-row>
      </vx-card>
    </form>

    <vs-popup
      v-if="file_preview_url"
      fullscreen
      class="preview-popup popup-1"
      :title="$t('labels.previewing_attachment')"
      :active.sync="popupPreview"
    >
      <VueDocPreview
        :url="file_preview_url"
        type="office"
        class="docPreview"
        width="100%"
        height="100%"
      />
      <!--      <iframe-->
      <!--        :src="`https://docs.google.com/gview?url=${file_preview_url}&embedded=true`"-->
      <!--        width="100%"-->
      <!--        height="100%"-->
      <!--        frameborder="0"-->
      <!--      ></iframe>-->
    </vs-popup>
    <vs-popup
      class="holamundo search-vessel popup-1"
      :title="$t('strings.select_client_for_vessel')"
      button-close-hidden
      :active.sync="popupActive"
    >
      <h4
        class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null"
        @click="closePopup()"
      >
        Skip
      </h4>
      <div class="flex justify-between">
        <span
          class="text-danger text-md self-end"
          v-if="vessel_validation == false"
          >{{ $t("strings.incomplete_vessel_details") }}</span
        >
        <div v-if="vessel_validation == false">
          <router-link
            class="view-link"
            :to="{ name: 'EditVessel', params: { id: vessel_edit_id } }"
            v-if="checkPermission('vessel', 'modify')"
          >
            <vs-button
              type="flat"
              :title="$t('labels.edit')"
              size="large"
              icon-pack="feather"
              icon="icon-edit"
              color="success"
              class="mr-2"
              @click="closePopup()"
            ></vs-button>
          </router-link>
        </div>
      </div>
      <div class="vx-col sm: w-full p-0 mt-4">
        <label class="bold-fields">{{ $t("labels.vessel") }}</label>
        <v-select
          v-model="type"
          name="vessel"
          label="name"
          class="mt-1"
          :options="vesselTypes"
          :reduce="(vesselTypes) => vesselTypes"
          :value="$store.myValue"
          @input="setSelectedVessel"
        />
        <!-- <span class="vessel_is_valid" v-if="!vessel_is_valid">
          It is incompleted vessel
        </span> -->
      </div>
      <div class="vx-row w-full m-0">
        <div class="vx-col sm: w-full md:w-1/2 pl-0 type pr-0">
          <label class="pl-1">{{ $t("labels.owner") }}</label>
          <vs-input
            type="text"
            class="w-full mb-0 mt-1"
            name="owner"
            maxlength="250"
            v-model="owner"
            icon-no-border
            disabled="true"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/2 type mt-4 md:mt-0 pr-0">
          <label class="pl-1">{{ $t("labels.manager") }}</label>
          <vs-input
            type="text"
            class="w-full mb-0 mt-1"
            name="manager"
            maxlength="250"
            v-model="manager"
            icon-no-border
            disabled="true"
          />
        </div>
      </div>
      <div class="vx-row w-full m-0 mt-4">
        <div class="vx-col sm: w-full md:w-1/2 pl-0 type pr-0">
          <label class="pl-1">{{ $t("labels.office") }}</label>
          <vs-input
            type="text"
            class="w-full mb-0 mt-1"
            name="office"
            maxlength="250"
            v-model="office"
            icon-no-border
            disabled="true"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/2 type pr-0 sm: mt-4 md:mt-0">
          <label class="pl-1">{{ $t("labels.fleet") }}</label>
          <vs-input
            type="text"
            class="w-full mb-0 mt-1"
            name="fleet"
            maxlength="250"
            v-model="fleet"
            icon-no-border
            disabled="true"
          />
        </div>
      </div>
    </vs-popup>
    <vs-popup
      :title="$t('strings.add_vessel')"
      class="holamundo search-vessel popup-1"
      :active.sync="addVesslePopup"
      style="min-width: 700px"
    >
      <div class="vx-row w-full m-0 mb-4">
        <div class="vx-col sm: w-full md:w-1/2 mb-4 pl-0">
          <label>{{ $t("labels.name") }}</label>
          <vs-input
            type="text"
            maxlength="50"
            class="w-full mt-1"
            name="name"
            v-model="name"
            icon-no-border
          />
          <!-- <span v-if="isName" class="text-danger text-sm">Enter the name</span> -->
        </div>
        <div class="vx-col sm: w-full type md:w-1/2 mb-4 pr-0">
          <label>{{ $t("labels.imo_number") }}</label>
          <vs-input
            type="text"
            maxlength="7"
            class="w-full mt-1"
            name="imo_number"
            v-model="imo_number"
            icon-no-border
          />
          <!-- <span v-if="isImo_number" class="text-danger text-sm"
            >Enter the imo number</span
          > -->
        </div>
        <div class="vx-row w-full m-0">
          <div class="vx-col sm: w-full md:w-1/2 pl-0 mt-4">
            <label>{{ $t("labels.type") }}</label>
            <v-select
              v-model="parent_id"
              :options="parentVesselTypes"
              :reduce="(parentVesselTypes) => parentVesselTypes.id"
              :value="$store.myValue"
              @input="setSelectedVesselType"
              label="name"
              class="mt-1"
            />
            <!-- <span v-if="isParentId" class="text-danger text-sm"
              >Enter the parent_id</span
            > -->
          </div>
          <div class="vx-col sm: w-full md:w-1/2 pr-0 mt-4">
            <label>{{ $t("labels.subtype") }}</label>
            <v-select
              v-model="subtype"
              :options="subtypes"
              :reduce="(subtypes) => subtypes.id"
              :value="$store.myValue"
              :label="'name'"
              name="subtype"
              class="mt-1 custome-select"
            />
            <!-- <span v-if="isSubType" class="text-danger text-sm"
              >Enter the subType</span
            > -->
          </div>
        </div>
        <div
          class="vx-col w-full pl-0 pr-0 mt-6 flex sm: justify-center md:justify-start"
        >
          <label>{{ $t("labels.vessel_status") }}:</label>
          <vs-switch color="primary" v-model="is_active" class="ml-4">
            <span slot="on"></span>
            <span slot="off"></span>
          </vs-switch>
        </div>
      </div>

      <div class="save_vessel">
        <vs-button @click="addNewVessel">Save</vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Attach Documents" :active.sync="popupActiveRaiseQuery">
      <file-picker
        :ref="filePickerRef"
        name="work_instructions_attachment"
        :acceptFormat="['.doc', '.docx']"
        :isMultiple="false"
      ></file-picker>

      <div class="mt-6 submit-btn flex justify-end">
        <vs-button
          class="vs-component vs-button vs-button-primary vs-button-filled login-btn"
          color="primary"
          @click="uploadFiles()"
        >
          Upload
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
/* import Datepicker from "vuejs-datepicker"; */
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VueDocPreview from "vue-doc-preview";
import moment from "moment";
import Vue from "vue";
import InspectionImage from "@/components/inspection-image";
import FilePicker from "@/components/file-picker.vue";

export default {
  data() {
    return {
      parent_id: null,
      parentVesselTypes: [
        {
          name: this.$t("labels.no_parent"),
          id: null,
        },
      ],
      date: null,
      file_preview_url: null,
      type: null,
      vesselTypes: [],
      popupPreview: false,
      project_name: "",
      admin: [],
      admins: [],
      travel_requirements: "",
      service: [],
      services_drop: [],
      port_id: null,
      ports: [],
      consultants_drop: [],
      consultant: [],
      remarks: "",
      consultant_services_array: [],
      status: "",
      cancel: "",
      owner: null,
      manager: null,
      office: null,
      fleet: null,
      owners: [],
      managers: [],
      offices: [],
      fleets: [],
      selected_owner: "",
      selected_type: "",
      popupActive: false,
      showPopupFlag: false,
      anotherPopupTitle: "",
      addVesslePopup: false,
      configdateTimePicker: {
        altFormat: "d-M-Y",
        allowInput: true,
        dateFormat: "d-M-Y",
      },
      vessel_validation: true,
      vessel_edit_id: null,
      is_completed_data: 0,
      subtypes: [],
      subtype: null,
      name: "",
      imo_number: "",
      is_active: false,
      selected_country: "",
      countries: [],
      shipImage: null,
      project_id: null,

      sections: [],
      vesselTypeInfo: null,
      vesselSubTypeInfo: null,
      projectInfo: null,
      popupActiveRaiseQuery: false,
      workAttachmentIndex: null,
    };
  },
  watch: {
    consultant() {
      this.consultantServices();
    },
    service() {
      this.consultantServices();
      this.checkServiceArr();
    },
    popupPreview(val) {
      if (!val) {
        this.file_preview_url = null;
      }
    },
    // owner(value) {
    //   if (value === null || value === "") {
    //     this.manager = null;
    //     this.managers = [];
    //   } else {
    //     this.managerActive = false;
    //     this.getManagers();
    //   }
    // },
    // manager(value) {
    //   if (value === null || value === "") {
    //     this.office = null;
    //     this.offices = [];
    //   } else {
    //     this.officeActive = false;
    //     this.getOffices();
    //   }
    // },
    // office(value) {
    //   if (value === null || value === "") {
    //     this.fleet = null;
    //     this.fleets = [];
    //   } else {
    //     this.fleetActive = false;
    //     this.getFleets();
    //   }
    // },
    // country(value) {
    //   if (value === null || value === "") {
    //     this.fleet = null;
    //     this.fleets = [];
    //   } else {
    //     this.getPorts();
    //   }
    // },
    parent_id(value) {
      if (value === null || value === "") {
        this.subtype = null;
        this.subtypes = [];
      } else {
        this.getSubtypes();
      }
    },
    fleet(value) {
      if (value) {
        // this.popupActive = false;
      }
    },
    type(value) {
      if (value) {
        // this.popupActive = false;
        this.selected_type = value.name;
      }
    },
    is_completed_data(val) {
      if (val == 0) {
        this.popupActive = true;
      } else {
        this.popupActive = false;
      }
    },
  },
  components: {
    flatPickr,
    VueDocPreview,
    InspectionImage,
    FilePicker,
  },
  computed: {
    mappedFolder() {
      if (this.currentSection) {
        const subFolders =
          (this.currentSection && this.currentSection.subFolders) || [];
        if (subFolders.length) {
          return subFolders
            .map((v, index) => ({
              index,
              ...v,
            }))
            .filter((v) => v.location);
        }
      }
      return [];
    },
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    },
    filePickerRef() {
      return "filePicker" + this.workAttachmentIndex;
    },
  },
  async mounted() {
    this.setValidationMessage();
    this.getAdmins();
    this.getPorts();
    this.getServices();
    this.getOwners();
    this.getConsultants();
    this.getVessel();
    this.getParentVesselTypes();
    if (this.editRoute) {
      this.getProject();
      this.getProjectFolderSubFolder(this.editRoute);
    }
  },
  methods: {
    async getParentVesselTypes() {
      let input = {
        only_parents: true,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let vesselTypes = response.data.vesselTypes;
        let filteredTypes = [];
        for (var i = 0; i < vesselTypes.length; i++) {
          let obj = { id: vesselTypes[i].id, name: vesselTypes[i].name };
          filteredTypes.push(obj);
        }
        this.parentVesselTypes = this.parentVesselTypes.concat(filteredTypes);
      }
    },
    setSelectedVesselType(value) {
      if (this.parent_id != null) {
        this.is_validation = true;
      }
      //fist clear selected service and its dropdown array
      this.subtype = null;
      this.subtypes = [];
      //set current v -select value as a selected_con
      this.selected_vesseltype = value;

      // get services for selected cont
      let subtype_req = this.subtypes;
      let filteredSubTypes = [];
      for (var i = 0; i < subtype_req.length; i++) {
        let obj = { id: subtype_req[i].id, name: subtype_req[i].name };
        filteredSubTypes.push(obj);
      }
      this.subtypes = filteredSubTypes;
    },
    async getSubtypes() {
      var input = {
        parent_id: this.parent_id,
      };
      let response = await this.getHTTPPostResponse("vesselType/list", input);
      if (response) {
        let data = response.data.vesselTypes;
        this.subtypes = data;
      }
    },
    async checkValidation(status) {
      this.status = status;
      if (this.status == "DR") {
        this.$validator.validate("form1").then(async (result) => {
          if (result) {
            this.createUpdateProject();
          }
        });
      } else {
        this.$validator.validate().then(async (result) => {
          if (result) {
            this.createUpdateProject();
          }
        });
      }
    },
    // quick vessel add for admin in project add screen
    async addNewVessel() {
      let input = {
        name: this.name,
        imo_number: this.imo_number,
        type_id: this.parent_id,
        sub_type_id: this.subtype,
        is_active: this.is_active,
      };
      let response = await this.getHTTPPostResponse("/vessels/create", input);
      if (response) {
        this.addVesslePopup = false;
      }
      this.selected_type = response.data.vessel.name;
      this.type = response.data.vessel;
      this.getVessel();
      this.name = "";
      this.imo_number = "";
      this.parent_id = "";
      this.subtype = "";
      this.is_active = false;
      this.getFoldersSubFolders({
        vessel_type_id: this.parent_id,
        vessel_sub_type_id: this.subtype,
      });
    },
    consultantServices() {
      let new_array = [];
      for (var i = 0; i < this.consultant.length; i++) {
        var consultant_id = this.consultant[i].id;
        var consultant_name = this.consultant[i].name;
        let index = this.consultant_services_array.findIndex(
          (item) => item.consultant_id === consultant_id
        );
        new_array.push({
          checkall:
            index !== -1
              ? this.consultant_services_array[index].checkall
              : false,
          consultant_id: consultant_id,
          consultant_name: consultant_name,
          work_instructions_text:
            index !== -1
              ? this.consultant_services_array[index].work_instructions_text
              : "",
          work_instructions_attachment:
            index !== -1
              ? this.consultant_services_array[index]
                  .work_instructions_attachment
              : [],
          service_ids:
            index !== -1
              ? this.consultant_services_array[index].service_ids
              : [],
        });
      }
      this.consultant_services_array = new_array;
    },
    checkServiceArr() {
      let data = this.consultant_services_array;
      if (data) {
        data.forEach((el) => {
          el.service_ids.forEach((serviceIds, i) => {
            if (
              !this.service.some((serviceData) => serviceData.id === serviceIds)
            ) {
              el.service_ids.splice(i, 1);
            }
          });
        });
      }
    },
    checkAllServices(e, index) {
      let data = this.consultant_services_array[index];
      let st = [];
      if (!data.checkall) {
        this.service.forEach((service) => {
          st.push(service.id);
        });
      } else {
        st = [];
      }
      data.service_ids = st;
      this.consultant_services_array[index] = data;
    },
    checkServices(e, index) {
      setTimeout(() => {
        let data = this.consultant_services_array[index];
        if (data.service_ids.length != this.service.length) {
          data.checkall = false;
        } else {
          data.checkall = true;
        }
        this.consultant_services_array[index] = data;
      }, 200);
    },
    // API Integration for vessel types
    async getVessels(
      input = {
        only_parents: true,
        with_children: true,
        client_id: this.fleet || this.office || this.manager || this.owner,
      }
    ) {
      let response = await this.getHTTPPostResponse("/vessels/list", input);
      if (response) {
        let types = response.data.vessels;
        //this.vesselTypes = types;
        if (
          types.length > 0 &&
          (this.fleet || this.office || this.manager || this.owner)
        ) {
          this.owner = response.data.vessels[0].owner
            ? response.data.vessels[0].owner.name
            : null;
          this.manager = response.data.vessels[0].manager
            ? response.data.vessels[0].manager.name
            : null;
          this.office = response.data.vessels[0].office
            ? response.data.vessels[0].office.name
            : null;
          this.fleet = response.data.vessels[0].fleet
            ? response.data.vessels[0].fleet.name
            : null;
        }
        return response;
      }
    },
    // API Integration for adimins
    async getAdmins(
      input = {
        type: "A",
      }
    ) {
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let admin_req = response.data.users;
        let filteredAdmin = [];
        for (var i = 0; i < admin_req.length; i++) {
          let obj = { id: admin_req[i].id, name: admin_req[i].name };
          filteredAdmin.push(obj);
        }
        this.admins = filteredAdmin;
      }
    },
    // API Integration for services
    async getPorts() {
      var input = {
        name: this.port,
      };
      let response = await this.getHTTPPostResponse("/ports/list", input);
      if (response) {
        let data = response.data;
        let ports = data.ports;
        this.ports = ports;
      }
    },

    async getServices() {
      let input = {
        name: this.service,
      };
      let response = await this.getHTTPPostResponse("/services/list", input);
      if (response) {
        let service_req = response.data.services;
        let filteredServices = [];
        for (var i = 0; i < service_req.length; i++) {
          let obj = { id: service_req[i].id, name: service_req[i].name };
          filteredServices.push(obj);
        }
        this.services_drop = filteredServices;
      }
    },
    // API Integration for consultants
    async getConsultants() {
      let input = {
        type: "CN",
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let consultant_req = response.data.users;
        let filteredConsultants = [];
        for (var i = 0; i < consultant_req.length; i++) {
          let obj = {
            id: consultant_req[i].id,
            name: consultant_req[i].name,
          };
          filteredConsultants.push(obj);
        }
        this.consultants_drop = filteredConsultants;
      }
    },
    async getOwners() {
      var input = {
        type: "CL",
        sub_type: "OW",
      };
      let response = await this.getHTTPPostResponse("/users", input);
      if (response) {
        let data = response.data.users;
        this.owners = data;
      }
    },
    async getManagers() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.owner);
      if (response) {
        let user = response.data.user;
        this.managers = user.children;
      }
    },
    async getOffices() {
      let response = await this.getHTTPGetResponse(
        "/users/get/" + this.manager
      );
      if (response) {
        let user = response.data.user;
        this.offices = user.children;
      }
    },
    async getFleets() {
      let response = await this.getHTTPGetResponse("/users/get/" + this.office);
      if (response) {
        let user = response.data.user;
        this.fleets = user.children;
      }
    },
    setSelectedOwner(value) {
      //fist clear selected manager and its dropdown array
      this.manager = null;
      this.managers = [];
      this.type = null;
      this.vesselTypes = [];
      //set current v -select value as a selected_owner
      this.selected_owner = value;

      // get managers for selected owner
      let manager_req = this.managers;
      let filteredManagers = [];
      for (let i = 0; i < manager_req.length; i++) {
        let obj = { id: manager_req[i].id, name: manager_req[i].name };
        filteredManagers.push(obj);
      }
      this.managers = filteredManagers;

      let vessel_req = this.vesselTypes;
      let filteredVessel = [];
      for (let i = 0; i < vessel_req.length; i++) {
        let obj = { id: vessel_req[i].id, name: vessel_req[i].name };
        filteredVessel.push(obj);
      }
      this.vesselTypes = filteredVessel;
    },
    setSelectedVessel(value) {
      if (value.is_completed_data == 1) {
        this.is_completed_data = 1;
      } else {
        this.is_completed_data = 0;
      }
      this.owner = value.owner ? value.owner.name : null;
      this.manager = value.manager ? value.manager.name : null;
      this.office = value.office ? value.office.name : null;
      this.fleet = value.fleet ? value.fleet.name : null;
      if (this.owner && this.manager && this.office && this.fleet) {
        // this.popupActive = false;
        this.selected_type = value.name;
        this.vessel_validation = true;
      } else {
        this.vessel_edit_id = value.id;
        this.selected_type = value.name;
        this.vessel_validation = false;
      }

      this.getVesselFolderSubFolder(value.id);
    },

    async getVesselFolderSubFolder(vessel_id) {
      let response = await this.getHTTPGetResponse(
        `/vessels/get/${vessel_id}/folder/subfolder`
      );

      if (response) {
        let data = response.data;
        if (data && data.folders) {
          if (data.folders.length) {
            this.sections = data.folders.map((v) => {
              return {
                ...v,
                id: null,
                imageUrl: v.ga_plan_image || null,
                location: v.location ? JSON.parse(v.location) : null,
                subFolders: v.subFolders.map((subFolder) => ({
                  ...subFolder,
                  id: null,
                  location: subFolder.location
                    ? JSON.parse(subFolder.location)
                    : null,
                })),
              };
            });
            this.vesselTypeInfo = data.vessel_type;
            this.vesselSubTypeInfo = data.vessel_sub_type;
          }
        }
      }
      this.sectionsLength = this.sections.length;
    },
    async getFoldersSubFolders(payload) {
      const { vessel_type_id, vessel_sub_type_id } = payload;

      let response = await this.getHTTPGetResponse(
        `/folders/subfolder/list?vessel_type_id=${vessel_type_id}&vessel_sub_type_id=${vessel_sub_type_id}`
      );

      if (response) {
        let data = response.data;
        if (data && data.folders) {
          this.sections = data.folders.map((folder) => ({
            folder_name: folder.folder_name,
            ga_plan_image: folder.ga_plan_image,
            location: folder.location ? JSON.parse(folder.location) : null,
            subFolders:
              folder.subFolders.map((subFolder) => ({
                folder_name: subFolder.folder_name,
                location: subFolder.location
                  ? JSON.parse(subFolder.location)
                  : null,
              })) || [],
          }));
          this.currentFolderIndex = this.folders.length ? 0 : null;
          this.vesselTypeInfo = data.vessel_type;
          this.vesselSubTypeInfo = data.vessel_sub_type;
        }
      }
    },
    // API Integration for Create Update Project
    async createUpdateProject() {
      let service = [];
      if (this.service.length > 0) {
        this.service.forEach((element) => {
          service.push(element.id);
        });
      }
      let projectDate = moment(this.date).format("Y-M-DD");
      let input = {
        name: this.project_name,
        date: projectDate + " 00:00:00",
        vessel_id: this.type ? this.type.id : null,
        reviewer_id: this.admin ? this.admin.id : null,
        remarks: this.remarks,
        service_ids: service,
        port_id: this.port_id,
        consultant_services_map: this.consultant_services_array,
        status: this.status,
        ship_url:
          this.vesselSubTypeInfo && this.vesselSubTypeInfo.ship_image_url
            ? this.vesselSubTypeInfo.ship_image_url
            : null,
      };

      this.addEditProjectWithFolder(input);
      return;
    },
    async addEditProjectWithFolder(input) {
      const vessel_id = input.vessel_id;
      const childData = this.$refs.inspectionImg.sections;
      const hasRedPin = childData.some(
        (section) =>
          (section.location && section.location.color === "red") ||
          section.subFolders.some(
            (subfolder) =>
              subfolder.location && subfolder.location.color === "red"
          )
      );
      if (hasRedPin) {
        this.$vs.notify({
          title: "Error.",
          text: "Please map the folder location",
          color: "danger",
          position: "top-right",
        });
        return;
      } else {
        const foldersPayload = childData.map((v) => ({
          id: v.id || null,
          folder_name: v.folder_name,
          imageBlob: v.file || null,
          ga_plan_image: v.file ? null : v.ga_plan_image,
          location:
            v.location && v.location.color != "red"
              ? JSON.stringify({ x: v.location.x, y: v.location.y })
              : null,
          subFolders: v.subFolders.map((subfolder) => {
            const location =
              subfolder.location && subfolder.location.color != "red"
                ? subfolder.location
                : null;
            return {
              id: subfolder.id || null,
              folder_name: subfolder.folder_name,
              location: location
                ? JSON.stringify({ x: location.x, y: location.y })
                : null,
            };
          }),
        }));

        let formData = new FormData();
        for (const key in input) {
          if (Object.hasOwnProperty.call(input, key)) {
            const element = input[key];
            if (Array.isArray(element)) {
              formData = this.formDataAppend(element, formData, key);
            } else {
              formData.append(key, element);
            }
          }
        }
        formData.append("vessel_id", vessel_id);
        foldersPayload.forEach((folder, folder_index) => {
          if (folder.id) {
            formData.append(`folders[${folder_index}][id]`, folder.id);
          }
          formData.append(
            `folders[${folder_index}][folder_name]`,
            folder.folder_name
          );
          if (folder.imageBlob)
            formData.append(
              `folders[${folder_index}][imageBlob]`,
              folder.imageBlob
            );

          if (folder.ga_plan_image)
            formData.append(
              `folders[${folder_index}][ga_plan_image]`,
              folder.ga_plan_image
            );

          if (folder.location)
            formData.append(
              `folders[${folder_index}][location]`,
              folder.location
            );

          folder.subFolders.forEach((subfolder, subFolderIndex) => {
            if (subfolder.id) {
              formData.append(
                `folders[${folder_index}][subFolders][${subFolderIndex}][id]`,
                subfolder.id
              );
            }
            formData.append(
              `folders[${folder_index}][subFolders][${subFolderIndex}][folder_name]`,
              subfolder.folder_name
            );
            if (subfolder.location)
              formData.append(
                `folders[${folder_index}][subFolders][${subFolderIndex}][location]`,
                subfolder.location
              );
          });
        });

        let url = this.editRoute
          ? "/projects/update/" + this.editRoute
          : "/projects/create";
        let button_loader =
          this.status === "DR" ? "#save_as_draft" : "#save_as_new";
        let response = await this.getHTTPPostResponse(
          url,
          formData,
          button_loader,
          true
        );
        this.$refs.inspectionImg.resetFormDirty();
        if (response) {
          this.project_id = response.data.project.id;
          this.$router.push({ name: "Projects" });
        }
      }
    },

    formDataAppend(data, formData, formKey = "") {
      if (Array.isArray(data)) {
        data.forEach((item, index) => {
          const formDataKey = `${formKey}[${index}]`;
          if (typeof item === "object" || Array.isArray(item)) {
            formData = this.formDataAppend(item, formData, formDataKey);
          } else {
            formData.append(formDataKey, item);
          }
        });
      } else {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            const subElement = data[key];
            if (typeof subElement === "object" || Array.isArray(subElement)) {
              formData = this.formDataAppend(
                subElement,
                formData,
                `${formKey}[${key}]`
              );
            } else {
              formData.append(`${formKey}[${key}]`, subElement);
            }
          }
        }
      }

      return formData;
    },

    // API Integration for getData
    async getProject() {
      try {
        this.$vs.loading();

        let response = await this.getHTTPGetResponse(
          "/projects/get/" + this.editRoute
        );

        if (response) {
          let data = response.data;
          let project = data.project;

          // Set project information
          this.projectInfo = project;
          this.project_name = project.name;
          this.date = moment(project.date).format("Y-M-D");
          this.owner = project.owner_id;
          this.manager = project.manager_id;
          this.office = project.office_id;
          this.fleet = project.fleet_id;
          this.type = project.vessel;
          this.selected_type = project.vessel ? project.vessel.name : "";
          this.admin = project.reviewer;
          this.port_id = project.port_id;
          this.remarks = project.remarks;
          this.vesselTypeInfo = project.vessel_type;
          this.vesselSubTypeInfo = {
            ...project.vessel_sub_type,
            ship_image_url: project.ship_url,
          };

          // Initialize and set services
          this.service = [];
          let services = project.services;
          services.forEach((element) => {
            this.service.push(element);
          });

          // Initialize and set consultants
          this.consultant = [];
          let consultants = project.consultants;
          consultants.forEach((element) => {
            this.consultant.push(element);
          });

          // Fetch vessels
          await this.getVessels();

          // Map consultants data
          setTimeout(() => {
            let consultant_services_data = [];

            consultants.forEach((consultant) => {
              let ser_id = [];

              services.forEach((serve) => {
                ser_id.push(serve.id);
              });

              consultant_services_data.push({
                consultant_id: consultant.id,
                consultant_name: consultant.name,
                services: this.service,
                work_instructions_text:
                  consultant.project_consultant.work_instructions_text,
                work_instructions_attachment:
                  consultant.project_consultant.work_instructions_attachment,
                service_ids: ser_id,
                checkall: this.service.length === ser_id.length,
              });
            });

            this.consultant_services_array = consultant_services_data;
          }, 100);
        }
      } catch (error) {
        console.error("Error fetching project data:", error);
      } finally {
        this.$vs.loading.close();
      }
    },
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return decodeURIComponent(filename);
    },
    clearFileName(index, attachIndex) {
      this.consultant_services_array[index].work_instructions_attachment.splice(
        attachIndex,
        1
      );
    },
    async getVessel() {
      let input = {
        only_parents: true,
        with_children: true,
      };
      let response = await this.getHTTPPostResponse("/vessels/list", input);
      if (response) {
        let types = response.data.vessels;
        this.vesselTypes = types;
      }
    },
    closePopup() {
      this.popupActive = false;
    },
    goBack() {
      history.back();
    },

    async getProjectFolderSubFolder(projectId) {
      const response = await this.getHTTPGetResponse(
        `/projects/${projectId}/folder/subfolder/get-folders`
      );
      if (response) {
        const data = response.data;

        this.sections = data.folders.map((v) => {
          return {
            ...v,
            imageUrl: v.ga_plan_image || null,
            location: v.location ? JSON.parse(v.location) : null,
            subFolders: v.subFolders.map((subFolder) => ({
              ...subFolder,
              location: subFolder.location
                ? JSON.parse(subFolder.location)
                : null,
            })),
          };
        });
        this.currentSectionIndex = this.sections.length ? 0 : null;
      }
    },
    async uploadFiles() {
      this.$vs.loading();
      const files = this.$refs[this.filePickerRef].selectedFiles || [];

      for (let index = 0; index < files.length; index++) {
        let file = files[index].file;
        let fileFormat = file.name.split(".");

        if (fileFormat[1] === "doc" || fileFormat[1] === "docx") {
          let input = new FormData();
          input.append("directory", "work_instruction_attachment");
          input.append("attachment", file);

          try {
            let response = await this.getHTTPPostResponse(
              "/s3/upload",
              input,
              "",
              true
            );

            if (
              this.consultant_services_array[this.workAttachmentIndex]
                .work_instructions_attachment == ""
            ) {
              this.consultant_services_array[
                this.workAttachmentIndex
              ].work_instructions_attachment = [];
            }
            this.consultant_services_array[
              this.workAttachmentIndex
            ].work_instructions_attachment.push(response.data.url);
          } catch (error) {
            this.$vs.notify({
              title: "Upload Error.",
              text: `Failed to upload ${file.name}`,
              color: "danger",
              position: "top-right",
            });
          }
        } else {
          this.$vs.notify({
            title: "Error.",
            text: `Please upload MS Word format for file ${file.name}`,
            color: "danger",
            position: "top-right",
          });
        }
      }
      this.$refs[this.filePickerRef].selectedFiles = [];
      this.$vs.loading.close();
      this.popupActiveRaiseQuery = false;
    },
    showUploadPopup(index) {
      this.popupActiveRaiseQuery = true;
      this.workAttachmentIndex = index;
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}

.attachment-border {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 9px;
}

.cancel-file {
  align-self: center;
}

.vessel_is_valid {
  color: rgba(var(--vs-danger), 1);
  margin-left: 1px;
}

.skip_position {
  margin-top: -1px;
  margin-left: 535px;
  cursor: pointer;
}

.popup-1 .vs-popup--close {
  position: absolute;
  display: flex;
  padding: 8px;
  cursor: pointer;
  margin-top: -46px;
  margin-left: 533px;
  margin-right: 20px;
  -webkit-transform: translate(8px, -8px);
  transform: translate(8px, -8px);
  background: rgb(115, 194, 251);
  font-size: 17px;
  color: rgba(0, 0, 0, 0.6);
}

.save_vessel {
  margin-left: 250px;
  margin-top: 30px;
}

.btn-link {
  background: none !important;
  border: none;
  color: #04497c;
  padding: 0 !important;
  font-family: arial, sans-serif;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 8px;
  font-size: 15px;
}
</style>
